/* Money boundaries use integer minor units. Percentage pricing (the deployed discount) remains an estimate until Shopify returns a cart;
 * fixed pricing mirrors the staged fixed-amount Function and is used only when the theme setting says it is live. */
(function (scope) {
  'use strict';
  if (scope.Top1BundleCore) return;
  function int(value, fallback) { var n = Number(value); return Number.isSafeInteger(n) ? n : fallback; }
  function ladderTotals(raw) { return String(raw || '').split(',').map(function (v) { return int(v.trim(), 0); }).filter(function (v) { return v > 0; }); }
  function targetUnit(ladder, pairs) {
    if (!ladder.length || pairs < 1) return null;
    var n = Math.min(pairs, ladder.length);
    var total = ladder[n - 1];
    return total % n === 0 ? total / n : null;
  }
  function percentageMilli(base, target) { return Math.min(90000, Math.max(0, Math.round((base - target) * 100000 / base))); }
  function legacyUnit(base, target, referenceBase) {
    if (!target || !referenceBase || target >= referenceBase) return base;
    return base - Math.floor(base * percentageMilli(referenceBase, target) / 100000);
  }
  // Fixed-amount Function: each eligible line drops to the tier target, never below 10% of its base and never raised.
  function fixedUnit(base, target) {
    if (!target || base <= target) return base;
    return base - Math.min(base - target, Math.floor(base * 90 / 100));
  }
  function unitPrice(base, target, referenceBase, fixed) { return fixed ? fixedUnit(base, target) : legacyUnit(base, target, referenceBase); }
  // One shopper-facing money format everywhere in the builder: "$120.00". Pages state the currency once.
  function formatPrice(cents, currency, locale) {
    try { return new Intl.NumberFormat(locale || 'en-AU', { style: 'currency', currency: currency || 'AUD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(int(cents, 0) / 100); }
    catch (e) { return '$' + (int(cents, 0) / 100).toFixed(2); }
  }
  function formatMoney(cents, currency, locale) {
    return new Intl.NumberFormat(locale || 'en-AU', { style: 'currency', currency: currency || 'AUD', currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(int(cents, 0) / 100);
  }
  function cartVariantQuantities(cart) {
    return (cart && cart.items || []).reduce(function (counts, item) { var key = String(item.variant_id || item.id); counts[key] = (counts[key] || 0) + item.quantity; return counts; }, {});
  }
  function knownEligible(cart, productId) { return (cart && cart.items || []).filter(function (item) { return String(item.product_id) === String(productId); }); }
  function estimate(items, variants, ladder, cart, productId, eligible, fixed) {
    var existing = eligible ? knownEligible(cart, productId) : [];
    var pairs = existing.reduce(function (sum, i) { return sum + i.quantity; }, 0) + items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
    var first = existing[0];
    var ref = first ? first.original_price : items.length ? variants[String(items[0].id)].price : 0;
    var target = eligible ? targetUnit(ladder, pairs) : null;
    var base = 0, total = 0;
    items.forEach(function (item) {
      var price = variants[String(item.id)].price;
      base += price * item.quantity;
      total += unitPrice(price, target, ref, fixed) * item.quantity;
    });
    return { total: total, base: base, saving: base - total, combinedPairs: pairs, existingPairs: existing.reduce(function (sum, i) { return sum + i.quantity; }, 0) };
  }
  function createState(variantList, quantity, maximum, saved) {
    var variants = {};
    variantList.forEach(function (v) { variants[String(v.id)] = v; });
    var state = { mode: saved && saved.mode === 'mix' ? 'mix' : 'same', quantity: Math.max(1, Math.min(maximum, int(quantity, 1))), same: null, counts: {}, maximum: maximum, variants: variants };
    variantList.forEach(function (v) { state.counts[String(v.id)] = saved && saved.counts ? Math.max(0, Math.min(maximum, int(saved.counts[String(v.id)], 0))) : 0; });
    if (saved && variants[String(saved.same)] && variants[String(saved.same)].available) state.same = String(saved.same);
    return state;
  }
  function colourKey(name) { return String(name || '').toLowerCase().replace(/\s+/g, ''); }
  // A link belongs to the product that was opened, even when purchases use a single-pair product.
  function resolveEntryVariant(id, entries, variants) {
    if (id == null) return { explicit: false };
    id = String(id);
    var entry = /^\d+$/.test(id) ? (entries || []).filter(function (v) { return String(v.id) === id; })[0] : null;
    if (!entry) return { explicit: true, reason: 'invalid' };
    if (entry.hidden) return { explicit: true, reason: 'hidden', name: entry.name };
    if (!entry.available) return { explicit: true, reason: 'unavailable', name: entry.name };
    if (entry.name === 'Default Title') return { explicit: true, reason: 'colour-required' };
    var target = Object.keys(variants).map(function (key) { return variants[key]; }).filter(function (v) { return colourKey(v.name) === colourKey(entry.name); })[0];
    if (!target) return { explicit: true, reason: 'unmapped', name: entry.name };
    if (!target.available || target.stock === 0) return { explicit: true, reason: 'unavailable', name: entry.name };
    return { explicit: true, id: String(target.id), entryId: id, name: target.name };
  }
  function initialSelection(variantList, options) {
    var quantity = int(options.quantity, 0), saved = options.saved;
    var state = createState(variantList, quantity > 0 ? quantity : options.preset, options.maximum, saved);
    var entry = resolveEntryVariant(options.variant, options.entries || variantList, state.variants);
    if (entry.explicit) {
      // URL intent wins previous colour/mode/quantity. Pending requests are kept separately by the caller.
      state = createState(variantList, quantity > 0 ? quantity : options.preset, options.maximum);
      if (entry.id) state.same = entry.id;
    } else {
      if (quantity <= 0 && saved && saved.quantity) setQuantity(state, saved.quantity);
      if (!state.same && !saved && options.defaultColour) {
        var match = variantList.filter(function (v) { return v.available && v.stock !== 0 && colourKey(v.name) === colourKey(options.defaultColour); })[0];
        if (match) state.same = String(match.id);
      }
    }
    return { state: state, entry: entry };
  }
  function shippingProgress(cart, rule, currency, country, projectedTotal) {
    if (!rule || rule.verified !== true || rule.currency !== currency || rule.country !== country || int(rule.threshold, 0) <= 0) return { enabled: false, reason: 'unverified-rule' };
    if (!cart || cart.currency !== currency || int(cart.total_price, -1) < 0) return { enabled: false, reason: 'unknown-cart' };
    var estimated = projectedTotal != null;
    var total = estimated ? int(projectedTotal, -1) : cart.total_price;
    if (total < 0) return { enabled: false, reason: 'unknown-total' };
    return { enabled: true, estimated: estimated, total: total, threshold: rule.threshold, remaining: Math.max(0, rule.threshold - total), percent: Math.min(100, Math.floor(total * 100 / rule.threshold)), reached: total >= rule.threshold };
  }
  // What the eligible sleeve lines already in the cart cost now, and after this selection joins them.
  function cartChange(cart, items, variants, ladder, productId, eligible, fixed) {
    if (!cart || !Number.isSafeInteger(cart.total_price)) return null;
    var quote = estimate(items, variants, ladder, cart, productId, eligible, fixed), existing = eligible ? knownEligible(cart, productId) : [];
    var first = existing[0], target = eligible ? targetUnit(ladder, quote.combinedPairs) : null;
    var before = 0, after = 0;
    for (var i = 0; i < existing.length; i++) {
      var line = existing[i], final = int(line.final_line_price, -1);
      if (final < 0 || !Number.isSafeInteger(line.original_price)) return null;
      before += final;
      after += unitPrice(line.original_price, target, first.original_price, fixed) * line.quantity;
    }
    return { existingPairs: quote.existingPairs, combinedPairs: quote.combinedPairs, existingBefore: before, existingAfter: after, added: quote.total, increase: after - before + quote.total };
  }
  function projectedCartTotal(cart, items, variants, ladder, productId, eligible, fixed) {
    if (!cart || !Number.isSafeInteger(cart.total_price)) return null;
    var quote = estimate(items, variants, ladder, cart, productId, eligible, fixed), existing = eligible ? knownEligible(cart, productId) : [];
    var first = existing[0], target = eligible ? targetUnit(ladder, quote.combinedPairs) : null;
    var previous = 0, repriced = 0;
    for (var i = 0; i < existing.length; i++) {
      var line = existing[i], final = int(line.final_line_price, -1);
      // The public cart supplies final_line_price. Without it, do not manufacture a progress figure.
      if (final < 0 || !Number.isSafeInteger(line.original_price)) return null;
      previous += final;
      repriced += unitPrice(line.original_price, target, first.original_price, fixed) * line.quantity;
    }
    return Math.max(0, cart.total_price - previous + repriced + quote.total);
  }
  // Smallest number of extra pairs that reaches the verified free-delivery threshold, in either colour mode.
  // Same colour: more of the chosen colour. Mix: more of one colour already chosen (returned as `variant`), so a tap
  // can complete the selection instead of leaving pairs unchosen and the delivery message falling back.
  function shippingNudge(state, cart, rule, currency, country, ladder, productId, eligible, fixed) {
    var cartCounts = cartVariantQuantities(cart), status = selectionStatus(state, cartCounts);
    if (!status.ready) return null;
    var chosen = selection(state);
    if (!chosen.length) return null;
    var projected = projectedCartTotal(cart, chosen, state.variants, ladder, productId, eligible, fixed);
    var progress = shippingProgress(cart, rule, currency, country, projected);
    if (!progress.enabled || projected == null || progress.reached) return null;
    var limit, priceId;
    if (state.mode === 'same') {
      if (!state.same) return null;
      priceId = state.same;
      limit = Math.min(state.maximum, remainingStock(state.variants[state.same], cartCounts));
    } else {
      // The first chosen colour that still has spare stock once this selection is counted.
      var spare = 0;
      for (var c = 0; c < chosen.length && !priceId; c++) {
        var key = String(chosen[c].id), variant = state.variants[key];
        var left = variant && variant.available ? remainingStock(variant, cartCounts) - (state.counts[key] || 0) : 0;
        if (left > 0) { priceId = key; spare = left; }
      }
      if (!priceId) return null;
      limit = Math.min(state.maximum, state.quantity + spare);
    }
    for (var quantity = state.quantity + 1; quantity <= limit; quantity++) {
      var extra = quantity - state.quantity, items = state.mode === 'same' ? [{ id: Number(state.same), quantity: quantity }] : chosen.concat([{ id: Number(priceId), quantity: extra }]);
      var next = projectedCartTotal(cart, items, state.variants, ladder, productId, eligible, fixed);
      if (next != null && next >= rule.threshold) {
        var found = { quantity: quantity, extraPairs: extra, extraCost: Math.max(0, next - projected), mode: state.mode };
        if (state.mode === 'mix') found.variant = priceId;
        return found;
      }
    }
    return null;
  }
  function selectedCount(state) { return state.mode === 'same' ? state.same ? state.quantity : 0 : Object.keys(state.counts).reduce(function (s, key) { return s + state.counts[key]; }, 0); }
  function selection(state) {
    if (state.mode === 'same') return state.same ? [{ id: Number(state.same), quantity: state.quantity }] : [];
    return Object.keys(state.counts).filter(function (key) { return state.counts[key] > 0; }).map(function (key) { return { id: Number(key), quantity: state.counts[key] }; });
  }
  function remainingStock(variant, cartCounts) { return variant.stock == null ? Infinity : Math.max(0, variant.stock - (cartCounts[String(variant.id)] || 0)); }
  function selectionStatus(state, cartCounts) {
    var n = selectedCount(state), chosen = selection(state);
    if (n < state.quantity) return { ready: false, missing: state.quantity - n, excess: 0 };
    if (n > state.quantity) return { ready: false, missing: 0, excess: n - state.quantity };
    for (var i = 0; i < chosen.length; i++) {
      var variant = state.variants[String(chosen[i].id)];
      if (!variant.available || chosen[i].quantity > remainingStock(variant, cartCounts)) return { ready: false, stock: variant.name, missing: 0, excess: 0 };
    }
    return { ready: n > 0, missing: 0, excess: 0 };
  }
  function setMode(state, mode) {
    state.mode = mode === 'mix' ? 'mix' : 'same';
    if (state.mode === 'mix' && state.same && Object.keys(state.counts).every(function (key) { return state.counts[key] === 0; })) state.counts[state.same] = state.quantity;
  }
  // Apply a tapped free-delivery nudge: mix mode adds the extra pairs to the colour the nudge was priced with.
  function applyNudge(state, nudge, cartCounts) {
    if (!nudge) return false;
    var before = state.quantity;
    setQuantity(state, nudge.quantity);
    if (state.mode === 'mix' && nudge.variant && state.variants[String(nudge.variant)]) {
      for (var i = 0; i < state.quantity - before; i++) if (!changeMixed(state, nudge.variant, 1, cartCounts || {})) break;
    }
    return true;
  }
  function setQuantity(state, quantity) { state.quantity = Math.max(1, Math.min(state.maximum, int(quantity, state.quantity))); }
  function changeMixed(state, id, delta, cartCounts) {
    id = String(id); var variant = state.variants[id];
    if (!variant) return false;
    if (delta < 0 && state.counts[id] > 0) { state.counts[id]--; return true; }
    if (delta > 0 && variant.available && selectedCount(state) < state.quantity && state.counts[id] < remainingStock(variant, cartCounts)) { state.counts[id]++; return true; }
    return false;
  }
  function requestItems(items, requestId) { return items.map(function (item) { return { id: item.id, quantity: item.quantity, properties: { _top1_request: requestId } }; }); }
  function requestStatus(cart, requestId, expected) {
    var counts = {};
    (cart.items || []).filter(function (item) { return item.properties && item.properties._top1_request === requestId; }).forEach(function (item) { var key = String(item.variant_id || item.id); counts[key] = (counts[key] || 0) + item.quantity; });
    var found = Object.keys(counts).reduce(function (sum, key) { return sum + counts[key]; }, 0);
    var complete = found > 0 && expected.every(function (item) { return counts[String(item.id)] === item.quantity; }) && found === expected.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    return { complete: complete, partial: found > 0 && !complete, counts: counts };
  }
  async function fetchTimed(fetcher, url, options) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
    if (controller) options.signal = controller.signal;
    try { return await fetcher(url, options); } finally { if (timer) clearTimeout(timer); }
  }
  async function readCart(fetcher, cartUrl) {
    var response = await fetchTimed(fetcher, cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.total_price)) throw new Error('Your cart could not be checked. Please try again.');
    return cart;
  }
  async function addVerified(fetcher, addUrl, cartUrl, items, requestId) {
    var error, transportFailure = false;
    try {
      var response = await fetchTimed(fetcher, addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: requestItems(items, requestId) }) });
      var body = await response.json();
      if (response.status >= 500) transportFailure = true;
      if (!response.ok) error = body.description || body.message || 'Shopify could not add all your sleeves. Check your cart before trying again.';
    } catch (e) { transportFailure = true; error = 'The connection was interrupted. We are checking whether your sleeves reached the cart.'; }
    // Even a 422 may have added available stock. Never blindly repeat a mutation.
    try {
      var cart = await readCart(fetcher, cartUrl);
      var result = requestStatus(cart, requestId, items);
      return { cart: cart, status: result, error: result.complete ? null : transportFailure && !result.partial ? 'The add attempt was interrupted and no sleeves were found yet. Check your cart before trying again.' : error || 'Your sleeves were not added. Please try again.', uncertain: transportFailure && !result.complete && !result.partial };
    } catch (e) { return { cart: null, status: null, error: 'We could not confirm whether your sleeves were added. Check your cart before adding again.', uncertain: true }; }
  }
  var api = { int: int, ladderTotals: ladderTotals, targetUnit: targetUnit, legacyUnit: legacyUnit, fixedUnit: fixedUnit, unitPrice: unitPrice, formatMoney: formatMoney, formatPrice: formatPrice, cartChange: cartChange, cartVariantQuantities: cartVariantQuantities, knownEligible: knownEligible, estimate: estimate, createState: createState, initialSelection: initialSelection, resolveEntryVariant: resolveEntryVariant, colourKey: colourKey, shippingProgress: shippingProgress, projectedCartTotal: projectedCartTotal, shippingNudge: shippingNudge, applyNudge: applyNudge, selectedCount: selectedCount, selection: selection, selectionStatus: selectionStatus, remainingStock: remainingStock, setMode: setMode, setQuantity: setQuantity, changeMixed: changeMixed, requestItems: requestItems, requestStatus: requestStatus, readCart: readCart, addVerified: addVerified };
  scope.Top1BundleCore = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
